import type { Chat } from "@/components/layout/sidebar/types"

export type ChatGroup = {
  label: string
  chats: Chat[]
}

export function groupChatsByDate(chats: Chat[]): ChatGroup[] {
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)
  const weekAgo = new Date(today)
  weekAgo.setDate(weekAgo.getDate() - 7)

  const groups: ChatGroup[] = []
  const todayChats: Chat[] = []
  const yesterdayChats: Chat[] = []
  const weekChats: Chat[] = []
  const olderChats: Chat[] = []

  chats.forEach(chat => {
    const chatDate = new Date(chat.timestamp)

    if (chatDate >= today) {
      todayChats.push(chat)
    } else if (chatDate >= yesterday) {
      yesterdayChats.push(chat)
    } else if (chatDate >= weekAgo) {
      weekChats.push(chat)
    } else {
      olderChats.push(chat)
    }
  })

  if (todayChats.length > 0) {
    groups.push({ label: "Today", chats: todayChats })
  }
  if (yesterdayChats.length > 0) {
    groups.push({ label: "Yesterday", chats: yesterdayChats })
  }
  if (weekChats.length > 0) {
    groups.push({ label: "Last 7 days", chats: weekChats })
  }
  if (olderChats.length > 0) {
    groups.push({ label: "Older", chats: olderChats })
  }

  return groups
}
const STUDY_REFERENCE_MARKER = "[Interne Studienreferenzen"
const STUDY_REFERENCE_LINE = /\s*\[Interne Studienreferenzen[^\]]*\]?/g

// The backend kept study ids at the end of earlier answers until October 2026,
// and the model learned to write that line itself. It is not for patients.
export function stripStudyReferences(content: string): string {
  let clean = content.replace(STUDY_REFERENCE_LINE, "")
  // While streaming, hide a line that has only begun, e.g. "\n\n[Interne Stu".
  const start = clean.lastIndexOf("\n[")
  if (start !== -1 && STUDY_REFERENCE_MARKER.startsWith(clean.slice(start + 1))) {
    clean = clean.slice(0, start)
  }
  return clean.trimEnd()
}
